/* eslint-disable no-restricted-imports */
import { utagLinkChat, utagLinkPDP, utagViewArtificialPageView } from 'features/tealium';
import { initStickyHeaderPriceObserver } from 'features/stickyHeaderPrice';
import { baseAPIRequest } from 'utilities/http';
import { renderPayPalMessage, getPayPalLaterPaymentPlan } from 'features/paypal';
import { formatCurrency } from 'utilities/localization';
import { getRetailStoreInfoByZipCode } from 'features/storeAvailability/api';
import { getNearByStores } from 'features/bopus/api';
import AppProductPriceLegalNotice from 'apps/productPriceLegalNotice/desktop';
import { autoplayOnScroll } from 'utilities/video';
import { setGenericEvent } from 'features/tealium/ga4/custom';
import { openMessenger } from 'features/genesysCloud';
import { initBreadcrumbBack, initBreadcrumbTracking } from 'features/breadcrumbs';

import dynamicImport from '../../../../features/webpack/dynamicImport.macro';
import scrollToSection from '../scrollToSection';
import initProductReviews, { unmountProductReviews } from '../productReviews';
import initProductQuestionsAndAnswers, { unmountProductQuestionsAndAnswers } from '../productQuestionsAndAnswers';

// globals
const { isProfessional } = window.lp.globals;

function initCommon (pageState, employeeNumber, inStockLabelDays, shippingTerms, showPaypalLaterWidget) {

	const trackPDPEvents = utagLinkPDP();
	const trackArtificalPageViewEvent = utagViewArtificialPageView();

	const ui = {
		qtyFields: document.querySelectorAll('#QtyNormal, #QtyMultiProd, #QtyDimmerCombo, .pdHousingOptionsQTY'),
		freeShippingLabels: document.querySelectorAll(
			'.freeShippingOverMinimum'
		),
		buildTrackSystemBtn: document.querySelector('#pdViewFullTrackSystem'),
		// AR
		showInRoomBtn: document.querySelector('#showInRoomBtn'),
		// Product video autoplay
		productVideo: document.querySelector('.productDetailsSection-video video'),
		// store availability check
		pdCheckStoreAvailabilityWrapper: document.querySelector('#pdCheckStoreAvailabilityWrapper'),
		// ask a store associate
		pdAskStoreAssociateWrapper: document.querySelector('#pdAskStoreAssociateWrapper'),
		// need help with product
		pdNeedHelpLinkWrapper: document.querySelector('#pdNeedHelpLinkWrapper'),
		pdNeedHelpLink: document.querySelector('#pdNeedHelpLink'),
		nonStoreAreaInfo: document.querySelector('#nonStoreAreaInfo'),
		// stock check
		pdCheckStock: document.querySelectorAll('.pdCheckStock'),
		pdInStock: document.querySelectorAll('button.pdShippingTermsLink'), // there could be 2 links on a page
		pdInStockLabel: document.getElementById('pdInStockLabel'),
		// dimmer
		pdDimmer: document.querySelectorAll('#dimmerOnlyOption, #dimmerWithFacePlateOption'),
		dimmerWithFacePlateOption: document.getElementById('dimmerWithFacePlateOption'),
		// multi-product
		pdMultiProdSizeOptions: document.querySelectorAll('.multiProdSizeOptions'),
		pdMultiProductSizeOptionRadio: document.querySelectorAll('.multiProdSizeOptions input[type=radio]'),
		pdMultiProdStockCheck: document.getElementById('multiProdStock'),
		// base colors
		baseColorLinks: document.querySelectorAll('a[href="#all-base-colors"]'),
		otherOptionsContainer: document.querySelectorAll('.otherOptions .scrollable:not(.scrollable--disabled)'),
		dimmerProductRadio: document.querySelectorAll('input[name=dimmerProductRadio]'),
		scrollables: document.querySelectorAll('.scrollable:not(.scrollable--disabled)'),
		marginModalLink: document.querySelector('#marginModalLink'),
		checkKitComponentModalLink: document.querySelector('#checkKitComponentModalLink'),
		optionalControlsRadioWrapper: document.querySelectorAll('.optionalControlsRadioWrapper'),
		optionalControlsRadioBtns: document.querySelectorAll('input[name="optionalControls"]'),
		workStationBasesCheckWrapper: document.querySelectorAll('.workStationBasesCheckWrapper'),
		workStationBasesCheckBtns: document.querySelectorAll('input[name="workStationBases"]'),
		morePatternsLink: document.querySelector('.pdpMorePatterns'),
		allArtShadeLink: document.querySelector('#artShadeLinks .artShadeCategory'),
		showReturnPolicies: document.querySelector('.showReturnPolicies')
	};

	const methods = {
		initColorPlusSlider () {

			$('.colorPlus').find('.items').find('div:first-child').find('a:first-child')
				.addClass('active');

		},

		initScrollable: () => {

			const { scrollables } = ui;

			scrollables.forEach((scrollable) => {

				const scrollableEl = $(scrollable).scrollable();
				const scrollableApi = scrollableEl.data('scrollable');
				const { itemsPerSlide } = scrollable.dataset;
				const { disabledClass } = scrollableApi.getConf();
				const arrows = scrollableApi.getNaviButtons();
				const prevArrow = arrows.filter('.prev')[0];
				const nextArrow = arrows.filter('.next')[0];
				const slideCount = scrollableApi.getSize();
				let isSliding = false;

				// Fix Scrollable plugin scrolling and focus bugs when using keyboard naigation.
				// Move first item of next slide to the left-most position when pressing TAB key from last item
				const lastSlideItems = scrollable.querySelectorAll(`.pdScrollableThumb:nth-child(${itemsPerSlide})`);
				lastSlideItems.forEach((lastSlideItem) => {

					lastSlideItem.addEventListener('keydown', (e) => {

						if (!e.shiftKey && e.key === 'Tab') {

							if (isSliding) {

								e.preventDefault();
								return;

							}

							const nextSlide = lastSlideItem.parentElement.nextElementSibling;
							if (nextSlide) {

								e.preventDefault();

								const slideIndex = Number(nextSlide.dataset.slideIndex);

								isSliding = true;

								scrollableApi.seekTo(slideIndex, undefined, () => {

									nextSlide.querySelector('.pdScrollableThumb:first-child').focus();

									isSliding = false;

									// Fix arrow disabled state not getting updated when using keyboard navigation
									prevArrow.classList.remove(disabledClass);

									if (slideIndex === slideCount - 1) {

										nextArrow.classList.add(disabledClass);

									}

								});

							}

						}

					});

				});

				// Move last item of prev slide to the right-most position when pressimg SHIFT+TAB key from first item
				const firstSlideItems = scrollable.querySelectorAll('.pdScrollableThumb:first-child');
				firstSlideItems.forEach((firstSlideItem) => {

					firstSlideItem.addEventListener('keydown', (e) => {

						if (e.shiftKey && e.key === 'Tab') {

							if (isSliding) {

								e.preventDefault();
								return;

							}

							const prevSlide = firstSlideItem.parentElement.previousElementSibling;
							if (prevSlide) {

								e.preventDefault();

								const slideIndex = Number(prevSlide.dataset.slideIndex);

								isSliding = true;

								scrollableApi.seekTo(slideIndex, undefined, () => {

									prevSlide.querySelector('.pdScrollableThumb:last-child').focus();

									isSliding = false;

									// Fix arrow disabled state not getting updated when using keyboard navigation
									nextArrow.classList.remove(disabledClass);

									if (slideIndex === 0) {

										prevArrow.classList.add(disabledClass);

									}

								});

							}

						}

					});

				});

				// Sync aria-disabled with disabled class added/removed by the jQuery Tools scrollable plugin on arrows
				scrollable.parentElement.querySelectorAll('.browse').forEach((arrow) => {

					const callback = (mutationList) => {

						mutationList.forEach((mutation) => {

							const { target } = mutation;
							if (target.classList.contains(disabledClass)) {

								target.setAttribute('aria-disabled', true);

							} else {

								target.removeAttribute('aria-disabled');

							}

						});

					};

					const observer = new MutationObserver(callback);
					observer.observe(arrow, { attributes: true, attributeFilter: [ 'class' ] });

					// When pressing TAB key, focus on the first visible item from Prev and last visible item from Next
					arrow.addEventListener('keydown', (e) => {

						if (e.key !== 'Tab') {

							return;

						}

						const allSlides = scrollableApi.getItems();
						const currentSlideIndex = scrollableApi.getIndex();
						const currentSlide = allSlides[currentSlideIndex];

						if (!e.shiftKey) {

							if (arrow.classList.contains('prev')) {

								e.preventDefault();

								currentSlide.querySelector('.pdScrollableThumb:first-child').focus();

							}

						} else if (arrow.classList.contains('next')) {

							e.preventDefault();

							currentSlide.querySelector('.pdScrollableThumb:last-child').focus();

						}

					});

				});

			});

		},
		initStickyHeaderPrice: () => {

			const stickyHeader = document.getElementById('stickyHeader');
			if (!stickyHeader) {

				return;

			}

			const stickyAdditionalPrice = stickyHeader.querySelector('.priceAdditional');
			const productPricePanel = document.getElementById('pnlProductPrice');

			// For Multi-products pricing block change
			if (ui.pdMultiProdSizeOptions.length > 0) {

				const stickyPrice = stickyHeader.querySelector('.stickyPriceContainer__priceTop');

				initStickyHeaderPriceObserver({
					stickyPrice,
					stickyAdditionalPrice,
					productPricePanel,
					// no stickyPriceType and productPriceTypeSelector params because
					// priceType and price are combined in one container in productPriceSelector callback
					productPriceSelector: () => {

						// this includes priceType and price
						const selectedOption = document.querySelector('.multiProdSizeOptions__option.selected');
						return selectedOption ? selectedOption.querySelector('.stickyPriceContainer__priceTop') : null;

					},
					additionalPriceSelector: () => {

						const selectedOption = document.querySelector('.multiProdSizeOptions__option.selected');
						return selectedOption ? selectedOption.querySelector('.priceAdditional') : null;

					}
				});

			} else {

				// For regular products pricing block change (e.g. Color Customizable products and Related items)
				const stickyPrice = stickyHeader.querySelector('.stickyPrice');
				const stickyPriceType = stickyHeader.querySelector('.stickyPriceContainer__priceType');

				initStickyHeaderPriceObserver({
					stickyPrice,
					stickyPriceType,
					stickyAdditionalPrice,
					productPricePanel,
					productPriceSelector: '#lblPrice',
					productPriceTypeSelector: '.priceType'
				});

			}

		},
		toggleMultiProdPriceBlock: (selectedMultiProdRadio) => {

			if (selectedMultiProdRadio) {

				const scriptTemplate = document.getElementById(`multiProductTemplate_${selectedMultiProdRadio.value}`);
				const fragment = document.createRange().createContextualFragment(scriptTemplate.textContent);
				document.getElementById('pnlProductPrice').innerHTML =					fragment.querySelector('#pnlProductPrice').innerHTML;

			}

		},
		updateMultiProdShipArrivesDates: (shipMessage) => {

			const sep = document.querySelector('.stockCheckSep');

			if (shipMessage) {

				if (ui.pdInStock) {

					ui.pdInStock.forEach((el) => (el.innerHTML = shipMessage));

				}

				if (ui.pdMultiProdStockCheck) {

					ui.pdMultiProdStockCheck.classList.remove('hidden');

				}

				if (sep) {

					sep.classList.remove('hidden');

				}

			} else {

				if (ui.pdInStock) {

					ui.pdInStock.forEach((el) => (el.innerHTML = ''));

				}

				if (ui.pdMultiProdStockCheck) {

					ui.pdMultiProdStockCheck.classList.add('hidden');

				}

				if (sep) {

					sep.classList.add('hidden');

				}

			}

		},
		toggleMultiProdOpenBoxLink: ($selectedMultiProdRadio) => {

			if ($selectedMultiProdRadio.length > 0) {

				const openBoxLinkWrapper = document.getElementById('openBoxPdpLinkWrapper');
				const openBoxLink = document.getElementById('openBoxPdpLink');
				const openBoxUrl = $selectedMultiProdRadio.data('open-box-url');

				if (!openBoxLink) {

					return;

				}

				if (!openBoxUrl) {

					openBoxLink.href = '';
					openBoxLinkWrapper.classList.add('hidden');
					return;

				}

				openBoxLink.href = openBoxUrl;
				openBoxLinkWrapper.classList.remove('hidden');

			}

		},
		updateMultiProductTurntoTeaser: (data) => {

			const [ summary ] = data;
			const averageRating = summary?.averageRating ?? 0;
			const reviewCount = summary?.reviews ?? 0;
			const teaser = document.querySelector('.pdSummaryTeaser');
			pageState.reviewsSummaryData = summary;

			if (averageRating < 2.5 || reviewCount === 0) {

				teaser.classList.add('hidden');
				return;

			}

			let ratingClass;
			if (averageRating % 1 === 0) {

				ratingClass = `${Number(averageRating)}-0`;

			} else {

				const ratingInt = Number(parseFloat(averageRating).toFixed(1).split('.')[0]);
				const decimals = Number(parseFloat((averageRating % 1).toFixed(1)));
				if (decimals <= 0.2) {

					ratingClass = `${ratingInt}-0`;

				} else if (decimals >= 0.3 && decimals <= 0.7) {

					ratingClass = `${ratingInt}-5`;

				} else {

					ratingClass = `${Math.ceil(averageRating)}-0`;

				}

			}

			if (teaser) {

				const teaserStarLinks = document.querySelector('#pdSummaryTeaserStarsLink');
				const teaserReviewCount = document.querySelector('#pdSummaryTeaserReviewCount');
				const reviewStars = teaser.querySelector('.goldReviewStars');

				reviewStars.className = `goldReviewStars goldReviewStars--${ratingClass}`;
				teaserStarLinks.setAttribute('aria-label', `star rating, ${averageRating} out of 5`);
				teaserReviewCount.innerHTML = `${reviewCount} Review${reviewCount > 1 ? 's' : ''}`;
				teaser.classList.remove('hidden');

			}

		},
		updateMultiProductReviews: (data) => {

			if (pageState.reviewsData) {

				pageState.reviewsData = data;

				if (pageState.reviewsInitialized) {

					const productReviewsElement = document.querySelector('#productReviewsContainer');
					if (productReviewsElement) {

						unmountProductReviews(productReviewsElement);
						initProductReviews(pageState, productReviewsElement);

					}

				}

			}

		},
		updateMultiProductQuestionsAndAnswers: (data) => {

			if (pageState.questionsData) {

				pageState.questionsData = data;

				if (pageState.qaInitialized) {

					const productQuestionsAndAnswersElement = document.querySelector(
						'#productQuestionsAndAnswersContainer'
					);

					if (productQuestionsAndAnswersElement) {

						unmountProductQuestionsAndAnswers(productQuestionsAndAnswersElement);
						initProductQuestionsAndAnswers(pageState, productQuestionsAndAnswersElement);

					}

				}

			}

		},
		initProductPriceLegalNotice: () => {

			const container = document.querySelector('.strikedPdPriceTooltipWrapper');

			if (container) {

				const tooltipTrigger = container.querySelector('.AppProductPriceLegalNotice__trigger');
				AppProductPriceLegalNotice(container, tooltipTrigger);

			}

		},
		initOpenBoxExplainerTooltip: () => {

			const container = document.querySelector('.openBoxTagContainer');
			if (container) {

				const tooltipTrigger = container.querySelector('.openBoxExplainer__trigger');
				AppProductPriceLegalNotice(container, tooltipTrigger, {
					evtType: 'hover'
				}, '.openBoxExplainer', '.openBoxExplainer__content');

			}

		},
		initWhatIsOpenBoxTooltip: () => {

			const container = document.querySelector('.whatIsOpenBoxContainer');
			if (container) {

				const tooltipTrigger = container.querySelector('.whatIsOpenBox__trigger');
				AppProductPriceLegalNotice(container, tooltipTrigger, {
					evtType: 'hover'
				}, '.whatIsOpenBox', '.whatIsOpenBox__content');

			}

		}
	};

	const events = {
		openStoreAvailabilityModal: (e, view, defaultStore) => {

			e.preventDefault();
			const bopusZip = e.currentTarget.dataset.zip;
			const geoZip = e.currentTarget.dataset.geozip;

			import('pages/product/desktop/checkStoreAvailability/initCheckStoreAvailability').then((module) => {

				const initCheckStoreAvailability = module.default;
				initCheckStoreAvailability({
					shortSku: window.shortSku,
					view,
					zipCode: bopusZip || geoZip || '',
					defaultStore
				});

			});

		},
		openNeedHelpModal: (e, zipCode, stores) => {

			e.preventDefault();
			import('pages/product/desktop/needHelpWithProduct/initNeedHelpWithProduct').then((module) => {

				const initNeedHelpWithProduct = module.default;
				initNeedHelpWithProduct({
					shortSku: window.shortSku,
					stores,
					zipCode
				});

			});

		},

		checkStoreInfo: async (zipCode) => {

			try {

				if (zipCode) {

					const response = await getRetailStoreInfoByZipCode(zipCode);
					return response;

				}
				const response = await getNearByStores();
				return response.ApiResult;

			} catch (error) {

				console.log('error getting nearby stores:', error);

			}

		},

		openMarginModal: (e) => {

			e.preventDefault();

			const storeNumber = window.lp.globals.storeNumber === 0 ? 52 : window.lp.globals.storeNumber;

			trackPDPEvents({ eventAction: 'click-Show-Margin', eventLabel: `${window.shortSku}-${storeNumber}` });

			$(document.body).lpModal({
				onInit: true,
				width: 200,
				height: 84,
				content: $('#pnlMargin')
			});

		},
		openCheckKitModal: (e) => {

			e.preventDefault();
			if (window.lp.globals.isLoggedIn && employeeNumber > 0) {

				$(document.body).lpModal({
					onInit: true,
					width: 621,
					height: 530,
					content: $('#checkKitComponentModal')
				});

			} else {

				alert('You have been logged out, please log in and try again');

			}

		},

		selectOptionalControls: (e) => {

			const parent = e.target.parentElement;
			const id = parent.getAttribute('data-id');

			document.querySelectorAll('.pdOptionalControlsThumb').forEach((e) => e.classList.remove('active'));
			parent.className += ' active';
			document.getElementById(`optionalControlsRadio_${id}`).checked = true;

		},

		selectWorkStationBases: (e) => {

			const parent = e.target.parentElement;
			const currentTargetId = e.target.id;
			const shortSku = parent.getAttribute('data-id');
			const inputId = `workStationBasesCheck_${shortSku}`;
			const checkBox = document.getElementById(inputId);

			if (currentTargetId === inputId) {

				if (checkBox.checked) {

					parent.className += ' active';

				} else {

					parent.classList.remove('active');

				}

			} else if (checkBox.checked) {

				parent.classList.remove('active');
				checkBox.checked = false;

			} else {

				parent.className += ' active';
				checkBox.checked = true;

			}

		},

		openShippingModal: (e) => {

			e.preventDefault();
			dynamicImport('desktop/product-shipsInModal', '../shipsInModal').then((module) => {

				const initShipsInModal = module.default;
				initShipsInModal(shippingTerms);

			});

		},

		showInRoom: (e) => {

			e.preventDefault();

			lp.myScene.viewInRoomModal = $('body').lpModal({
				onInit: true,
				width: 500,
				height: 500,
				src: `/viewer/SceneView?pdp=1&skus=${window.shortSku}`,
				closeEvt: () => trackArtificalPageViewEvent({ pageName: '' }),
				openEvt: () => trackArtificalPageViewEvent({ pageName: 'View in your Room' })
			});

			trackPDPEvents({
				eventAction: 'Click-View-in-Your-Room',
				eventLabel: window.shortSku
			});
			setGenericEvent({
				event_name: 'pdp_viewinroom_click',
				pdp_item_id: window.shortSku,
				pdp_prime_cat: window.productCategory
			});

		},

		showFreeShippingOverlay: (e) => {

			$(e.target).lpModal({
				content: $('#freeShippingOverlay'),
				height: 198,
				width: 624,
				onInit: true,
				closeEvt: () => trackArtificalPageViewEvent({ pageName: '' }),
				openEvt: () => trackArtificalPageViewEvent({ pageName: 'Free shipping on most orders' })
			});

		},

		checkQty: (e) => {

			const txtQty = e.target;
			if (txtQty.value === '' || parseInt(txtQty.value, 10) <= 0) {

				txtQty.value = '1';

			}

		},

		handleSelectMultiProdSize: async (radioElem) => {

			const {
				toggleMultiProdPriceBlock,
				toggleMultiProdOpenBoxLink,
				updateMultiProdShipArrivesDates,
				updateMultiProductTurntoTeaser,
				updateMultiProductReviews,
				updateMultiProductQuestionsAndAnswers
			} = methods;
			const price = radioElem.getAttribute('data-price');
			const { firstShipDays, shipMessage } = radioElem.dataset;
			const removeLineBreaks = (str) => str.replace(/(\r\n|\n|\r)/gm, '');

			const $prodRadio = $(radioElem);

			const closestOption = radioElem.closest('.multiProdSizeOptions__option');
			const newOptionText = removeLineBreaks(
				closestOption.querySelector('.multiProdSizeOptions__option-text .listNameText').innerText
			);
			const pleaseCallMessage = document.querySelector('.pdPleaseCall');
			const addToCart = document.querySelector('#AddToCart_Multiproduct');

			// Find the group heading text for selected option
			let closestGroupHeader = closestOption.previousElementSibling;
			while (closestGroupHeader && !closestGroupHeader.classList.contains('multiProdSizeOptions__group-header')) {

				closestGroupHeader = closestGroupHeader.previousElementSibling;

			}
			const newGroupText = closestGroupHeader
				? ` ${removeLineBreaks(
					closestGroupHeader.querySelector('.multiProdSizeOptions__group-header-text').innerText
				  )}`
				: '';

			if (showPaypalLaterWidget) {

				let paymentPlan;
				// add a set timeout of 0 to delay render until element is visible
				// otherwise paypal hides message because element is hidden
				setTimeout(() => {

					renderPayPalMessage({
						amount: price,
						selector: '#paypalLaterWidget',
						onRender: (e) => {

							paymentPlan = getPayPalLaterPaymentPlan(e.meta?.creditProductIdentifier);

						},
						onClick: () => {

							trackPDPEvents({
								eventAction: 'Click-PayPal-Later-Popup',
								eventLabel: `${paymentPlan} for ${formatCurrency(price, false, false)}`
							});

						},
						onApply: () => {

							trackPDPEvents({
								eventAction: 'Click-PayPal-Later-Apply',
								eventLabel: `${paymentPlan} for ${formatCurrency(price, false, false)}`
							});

						}
					});

				}, 0);

			}

			document.querySelector(
				'.pdProdFullTitleSticky__subtitle'
			).innerText = `${newOptionText.trim()}${newGroupText.trim()}`;

			const $pdProdSku = $('#pdProdSku');
			const $volumePricing_multi = $('#volumePricing_multi');
			const isShowCallForVolumePricing = radioElem.getAttribute('isShowCallForVolumePricing');

			toggleMultiProdPriceBlock(radioElem);
			toggleMultiProdOpenBoxLink($prodRadio);

			// keep copy of original sku before updating
			const beforeUpdateSKU = window.shortSku;
			// update global shortSku var with the selected item
			window.shortSku = $prodRadio.attr('data-sku');

			$pdProdSku.empty();

			// reset quantity value to 1
			$('#QtyMultiProd').val(1);

			$pdProdSku.html(`Style # ${window.shortSku}`);

			if (isShowCallForVolumePricing === 'true') {

				$volumePricing_multi.toggleClass('hidden', false);

			} else {

				$volumePricing_multi.toggleClass('hidden', true);

			}

			// Update Arrive dates
			updateMultiProdShipArrivesDates(shipMessage);

			const { sku } = radioElem.dataset;

			// run updates only when sku has changed
			if (beforeUpdateSKU !== sku) {

				const getSummary = baseAPIRequest({
					url: `${lp.globals.userGeneratedContentBaseUrl}/summary/?shortSku=${sku}`,
					params: {
						method: 'GET'
					}
				});

				const getReviews = baseAPIRequest({
					url: `${lp.globals.userGeneratedContentBaseUrl}/reviews/?shortSku=${sku}&pageSize=5&pageNumber=1&sort=1`,
					params: {
						method: 'GET'
					}
				});

				const getQuestionsAndAnswers = baseAPIRequest({
					url: `${lp.globals.userGeneratedContentBaseUrl}/questions/?shortSku=${sku}&pageSize=5&pageNumber=1&sort=1`,
					params: {
						method: 'GET'
					}
				});

				Promise.all([ getSummary, getReviews, getQuestionsAndAnswers ]).then(
					([ summaryResponse, reviewsResponse, qaResponse ]) => {

						if (summaryResponse.isSuccess && reviewsResponse.isSuccess && qaResponse.isSuccess) {

							// Only covers case for Q&A and Review sections, where they haven't been initialized before sku change
							pageState.multiProductSkuChanged = true;

							updateMultiProductTurntoTeaser(summaryResponse.result);
							updateMultiProductReviews(reviewsResponse.result);
							updateMultiProductQuestionsAndAnswers(qaResponse.result);

						}

					}
				);

			}

			if (!window.lp.globals.isHospitality) {

				if (addToCart) {

					// toggle add to cart/qty and customer service message based on firstShipDays value
					if (Number(firstShipDays) >= 57) {

						addToCart.classList.add('hidden');
						pleaseCallMessage.classList.remove('hidden');

					} else {

						addToCart.classList.remove('hidden');
						pleaseCallMessage.classList.add('hidden');

					}

				}

				// toggle in stock label based on firstShipDays value
				if (ui.pdInStockLabel) {

					if (Number(firstShipDays) <= inStockLabelDays) {

						ui.pdInStockLabel.classList.remove('hidden');

					} else {

						ui.pdInStockLabel.classList.add('hidden');

					}

				}

			}

		},

		showBuildFullTrackSystem: (e) => {

			e.preventDefault();
			utagLinkPDP()({
				eventAction: `Click-BFS-${window.utag_data.product_category[0]}`,
				eventLabel: window.location.pathname
			});
			scrollToSection(e.target.hash);

		},

		toggleDimmerPriceBlock: (e) => {

			const paypalLater = document.getElementById('paypalLaterWidget');

			if (e.target.id === 'dimmerWithFacePlateOption') {

				$('#pnlProductPrice, #productPriceMeta, .stickyPriceContainer').addClass('hidden');
				$('.pdWithFacePlate').removeClass('hidden');
				paypalLater.classList.add('hidden');

			} else {

				$('#pnlProductPrice, #productPriceMeta, .stickyPriceContainer').removeClass('hidden');
				$('.pdWithFacePlate').addClass('hidden');
				paypalLater.classList.remove('hidden');

			}

		},

		showReturnPoliciesModal: (e) => {

			e.preventDefault();
			$(document.body).lpModal({
				onInit: true,
				lpModalClass: 'lpModal--alt1',
				width: 310,
				height: 185,
				content: $('#showReturnPoliciesContent')
			});

		},

		stockCheck: (e) => {

			e.preventDefault();
			const storeNumber = window.lp.globals.storeNumber === 0 ? 52 : window.lp.globals.storeNumber;
			const { sku } = e.currentTarget.dataset;
			const { componentSku } = e.currentTarget.dataset;

			trackPDPEvents({ eventAction: 'click-Check-Stock', eventLabel: `${sku}-${storeNumber}` });

			if (window.lp.globals.isLoggedIn && employeeNumber > 0 && componentSku == 0) {

				window.open(
					`https://stockcheck.lampsplus.com/store-quantity-check?showlogout=false&enableautoclosescript=true&employee=${employeeNumber}&storenumber=${storeNumber}&shortsku=${sku}`,
					'StockCheck',
					'toolbar=0,location=0,directories=0,status=0,menubar=0,scrollbars=1,resizable=0,width=1015,height=743,left=0,top=0'
				);

			} else if (window.lp.globals.isLoggedIn && employeeNumber > 0) {

				window.open(
					`https://stockcheck.lampsplus.com/store-quantity-check?showlogout=false&enableautoclosescript=true&employee=${employeeNumber}&storenumber=${storeNumber}&shortsku=${sku}&componentsku=${componentSku}`,
					'StockCheck',
					'toolbar=0,location=0,directories=0,status=0,menubar=0,scrollbars=1,resizable=0,width=1015,height=743,left=0,top=0'
				);

			} else {

				alert('You have been logged out, please log in and try again');

			}

		}
	};

	function init () {

		const { initScrollable, initColorPlusSlider, initStickyHeaderPrice } = methods;

		const {
			buildTrackSystemBtn,
			freeShippingLabels,
			pdCheckStoreAvailabilityWrapper,
			pdAskStoreAssociateWrapper,
			pdInStock,
			pdCheckStock,
			qtyFields,
			showInRoomBtn,
			productVideo,
			pdDimmer,
			dimmerWithFacePlateOption,
			pdMultiProdSizeOptions,
			pdMultiProductSizeOptionRadio,
			baseColorLinks,
			dimmerProductRadio,
			otherOptionsContainer,
			marginModalLink,
			checkKitComponentModalLink,
			optionalControlsRadioWrapper,
			optionalControlsRadioBtns,
			workStationBasesCheckWrapper,
			workStationBasesCheckBtns,
			morePatternsLink,
			allArtShadeLink,
			showReturnPolicies,
			pdNeedHelpLinkWrapper,
			pdNeedHelpLink,
			nonStoreAreaInfo
		} = ui;

		const {
			checkQty,
			openShippingModal,
			openStoreAvailabilityModal,
			showFreeShippingOverlay,
			showInRoom,
			showBuildFullTrackSystem,
			stockCheck,
			handleSelectMultiProdSize,
			openMarginModal,
			openCheckKitModal,
			selectOptionalControls,
			selectWorkStationBases,
			showReturnPoliciesModal,
			openNeedHelpModal,
			checkStoreInfo
		} = events;

		initStickyHeaderPrice();

		// multi-product
		if (pdMultiProdSizeOptions.length) {

			// Initial Multi Product ShortSKU
			$(pdMultiProdSizeOptions)
				.find('input[type=radio]')
				.each(function () {

					// must check for sku, otherwise it breaks the page and throws error in some cases
					const sku = this.getAttribute('data-sku');

					if (sku && sku.toLowerCase() === document.getElementById('initialShortSku').value.toLowerCase()) {

						$(this).attr('checked', 'checked');
						document.querySelector('.multiProdSizeOptions__option.selected').classList.remove('selected');
						this.closest('.multiProdSizeOptions__option').classList.add('selected');

					}

				});

			// Ensure at least one selection is made
			if ($(pdMultiProdSizeOptions).find('input[type=radio]:checked').length === 0) {

				$(pdMultiProdSizeOptions).find('input[type=radio]:first').trigger('click');

			}

			handleSelectMultiProdSize(document.querySelector('input[name="MultiproductRadio"]:checked'));

			// multi-product size options
			pdMultiProductSizeOptionRadio.forEach((r) => {

				r.addEventListener('click', (e) => handleSelectMultiProdSize(e.target));

			});

		}

		if (showReturnPolicies) {

			showReturnPolicies.addEventListener('click', showReturnPoliciesModal);

		}

		// show in room
		if (showInRoomBtn) {

			showInRoomBtn.addEventListener('click', showInRoom);

		}

		if (productVideo) {

			const autoplayObserver = autoplayOnScroll();
			autoplayObserver.observe(productVideo);

		}

		pdCheckStock.forEach((checkStock) => {

			checkStock.addEventListener('click', stockCheck);

		});

		methods.initProductPriceLegalNotice();
		methods.initOpenBoxExplainerTooltip();
		methods.initWhatIsOpenBoxTooltip();

		// qty fields
		qtyFields.forEach((field) => {

			field.addEventListener('blur', checkQty);

		});

		// shipping callouts
		freeShippingLabels.forEach((label) => {

			label.addEventListener('click', showFreeShippingOverlay);

		});

		if (buildTrackSystemBtn) {

			buildTrackSystemBtn.addEventListener('click', showBuildFullTrackSystem);

		}

		// stock check - shipping modal
		pdInStock.forEach((link) => {

			link.addEventListener('click', openShippingModal);

		});

		// store availability check
		if (pdCheckStoreAvailabilityWrapper) {

			const zip = pdCheckStoreAvailabilityWrapper.dataset.geozip || '';
			const [ productSku ] = window.utag_data.product_primary_sku;
			const [ productCategory ] = window.utag_data.product_category;

			checkStoreInfo(zip).then((stores) => {

				const [ store ] = stores;

				if (store) {

					const { StoreName: storeName, LocationNumber: storeNum } = store;
					const trackingData = {
						pdp_item_id: productSku,
						pdp_prime_cat: productCategory
					};

					if (storeName && storeNum) {

						trackingData.store_number_store_name = `${storeNum} ${storeName}`;

					}

					setGenericEvent({
						event_name: 'pdp_checkstore_load',
						...trackingData
					});

					pdCheckStoreAvailabilityWrapper.classList.remove('hidden');
					pdCheckStoreAvailabilityWrapper.addEventListener('click', (e) => {

						openStoreAvailabilityModal(e, 'CSA', store);

						trackArtificalPageViewEvent({ pageName: 'Check Store Availability' });

						setGenericEvent({
							event_name: 'pdp_checkstore_click',
							...trackingData
						});

					});

				}

			});

		}

		// need help with product
		if (pdNeedHelpLinkWrapper) {

			const zip = pdNeedHelpLinkWrapper.dataset.geozip || '';
			checkStoreInfo(zip).then((stores) => {

				const [ store ] = stores;
				const storeNumberAndName = store ? `${store.StoreName} #${store.LocationNumber}` : 'Non-Store Area';

				utagLinkPDP()({
					eventAction: 'Load-Product-Help',
					eventLabel: storeNumberAndName
				});

				const otherOptionWrapper = document.querySelector('.otherOptionWrapper');
				if (otherOptionWrapper) {

					pdNeedHelpLinkWrapper.classList.add('negativeTopMargin');

				}
				if (store) {

					if (pdNeedHelpLink) {

						setGenericEvent({
							event_name: 'pdp_producthelp_load',
							store_number_store_name: storeNumberAndName
						});

						pdNeedHelpLink.classList.remove('hidden');
						pdNeedHelpLink.addEventListener('click', (e) => {

							utagLinkPDP()({
								eventAction: 'Click-Product-Help',
								eventLabel: `${store.StoreName} #${store.LocationNumber}`
							});

							setGenericEvent({
								event_name: 'pdp_producthelp_click',
								store_number_store_name: storeNumberAndName
							});

							openNeedHelpModal(e, zip, stores);

						});

					}

				} else {

					if (isProfessional) {

						const formatPhoneNumber = (phone) => {

							if (!phone || phone.length < 10) {

								return;

							}

							phone = phone.replace(/[^A-Z0-9]+/gi, '');

							const startNum = phone.slice(0, 1) === '1' ? 1 : 0;
							const areaCode = phone.slice(startNum, 3);
							const localCode = phone.slice(3, 6);
							const number = phone.slice(6);
							return `${areaCode}-${localCode}-${number}`;

						};

						nonStoreAreaInfo.querySelector('.contactInfo b').innerHTML = formatPhoneNumber(
							window.lp.globals.proContact.phoneNumberWithoutExtn
						);

					}
					nonStoreAreaInfo.classList.remove('hidden');
					const chatText = document.querySelector('#nonStoreAreaInfo .chatText');
					if (chatText) {

						chatText.addEventListener('click', (e) => {

							document.querySelector('#nonStoreAreaInfo .chatButtonContainer button')?.click();

						});

					}

				}
				setTimeout(() => {

					const chatButton = document.querySelector('#nonStoreAreaInfo .chatButtonContainer button');
					if (chatButton) {

						chatButton.addEventListener('click', (e) => {

							if (e.target.closest('.chatButtonContainer button')) {

								openMessenger();
								utagLinkChat()({
									eventAction: 'Request-Chat',
									eventLabel: 'Product-Help-Store'
								});
								setGenericEvent({
									event_name: 'chat_click',
									chat_button_type: 'static',
									chat_button_text: e.target.innerHTML
								});

							}

						});

					}

				}, 1000);

			});

		}

		// buildfullsystem section live chat button
		const pdBuildFullSystemChatButton = document.querySelector('.pdBuildFullSystemTop .chatButtonContainer button');
		if (pdBuildFullSystemChatButton) {

			pdBuildFullSystemChatButton.addEventListener('click', (e) => {

				if (e.target.closest('.chatButtonContainer button')) {

					openMessenger();

				}

			});

		}

		// dimmer
		// Ensure the first Dimmer option is always selected by default
		$(dimmerProductRadio).first().trigger('click');

		pdDimmer.forEach((d) => {

			d.addEventListener('click', events.toggleDimmerPriceBlock);

		});

		if (showPaypalLaterWidget) {

			let paymentPlan;
			const amount = dimmerWithFacePlateOption?.getAttribute('data-price');
			renderPayPalMessage({
				amount,
				selector: '#pdWithFacePlatePaypalWidget',
				onRender: (e) => {

					paymentPlan = getPayPalLaterPaymentPlan(e.meta?.creditProductIdentifier);

				},
				onClick: () => {

					trackPDPEvents({
						eventAction: 'Click-PayPal-Later-Popup',
						eventLabel: `${paymentPlan} for ${formatCurrency(amount, false, false)}`
					});

				},
				onApply: () => {

					trackPDPEvents({
						eventAction: 'Click-PayPal-Later-Apply',
						eventLabel: `${paymentPlan} for ${formatCurrency(amount, false, false)}`
					});

				}
			});

		}

		$('body').append('<div id="optionalControlsTooltip"><div id="optionalControlsTooltipContent"></div></div>');

		// initialize tooltip
		$('.optionalControlsLink').lpTooltip({
			tooltip: $('#optionalControlsTooltip'),
			evtType: 'click',
			arrow: true,
			arrowBorderColor: '#999',
			arrowBorderWidth: 1,
			arrowColor: '#fff',
			vertAlign: 'top',
			horzAlign: 'center',
			showCloseBtn: true,
			closeOnTooltipBtnBlur: true,
			offsetX: 0,
			offsetY: 10
		});

		$('.optionalControlsLink').on('mousedown', function () {

			const html = $(this).parent().parent().find('.optionalControlsDetails')
				.clone()
				.html();
			$('#optionalControlsTooltipContent').html(html);

		});
		// close modal on blur
		$('.optionalControlsLink').on('blur', () => {

			$('.optionalControlsLink').trigger('forceClose.lpTooltip');

		});
		$('.optionalControlsLink').on('keyup', (e) => {

			// enter key
			if (e.which === 13) {

				$('.optionalControlsLink').trigger('mousedown');
				$('.optionalControlsLink').trigger('click');
				// escape key

			} else if (e.which === 27) {

				$('.optionalControlsLink').trigger('forceClose.lpTooltip');

			}

		});

		$('.lpAccordion').each((index, item) => {

			if ($.trim(item.innerHTML).length) {

				$(item).lpAccordion();

			}

		});

		// scrollables
		initScrollable();

		// colorplus slider
		initColorPlusSlider();

		// misc

		// fan feature help rollover divs
		$('.pdFanFeaturesHelpTrig')
			.hover(
				function () {

					$(this).next('.pdFanFeaturesHelpPop').fadeIn(200);

				},
				function () {

					$(this).next('.pdFanFeaturesHelpPop').fadeOut(500);

				}
			)
			.on('click', () => false); // prevent default behavior for tooltips

		// Other Options Scroller will start on the group with the active option.
		if ($(otherOptionsContainer).length) {

			const scrollableContainer = $(otherOptionsContainer)[0].closest('.lpCollapsible');
			const $options = $(otherOptionsContainer).find('.pdOtherOptionsThumb');
			let activeGroupIndex = $('.pdOtherOptionsThumb.active').closest('.items div').index();
			activeGroupIndex = activeGroupIndex > 0 ? activeGroupIndex : 0;

			// wait for options dropdown to expand to run collapsible and start to active group
			new MutationObserver((mutations, observer) => {

				const mutation = mutations[0];
				if (!mutation.target.classList.contains('collapsed')) {

					// run collapsible once by stopping observer
					$(otherOptionsContainer).scrollable().seekTo(activeGroupIndex, 0);
					observer.disconnect();

				}

			}).observe(scrollableContainer, {
				attributeFilter: [ 'class' ],
				attributes: true,
				subtree: false,
				childList: false
			});

			$options.on('click', function () {

				$options.removeClass('active');
				$(this).addClass('active');

			});

		}

		optionalControlsRadioWrapper.forEach((c) => {

			c.addEventListener('click', selectOptionalControls);

		});

		optionalControlsRadioBtns.forEach((c) => {

			c.addEventListener('click', selectOptionalControls);

		});

		workStationBasesCheckWrapper.forEach((c) => {

			c.addEventListener('click', selectWorkStationBases);

		});

		workStationBasesCheckBtns.forEach((c) => {

			c.addEventListener('click', selectWorkStationBases);

		});

		// margin
		if (marginModalLink) {

			marginModalLink.addEventListener('click', openMarginModal);

		}

		// Kit Component
		if (checkKitComponentModalLink) {

			checkKitComponentModalLink.addEventListener('click', openCheckKitModal);

		}

		// art shade links tracking
		if (morePatternsLink) {

			morePatternsLink.addEventListener('click', () => {

				utagLinkPDP()({
					eventAction: 'Click-More-Patterns',
					eventLabel: window.shortSku
				});
				setGenericEvent({
					event_name: 'pdp_artshade_patterns_viewall',
					pdp_item_id: window.shortSku,
					pdp_prime_cat: window.productCategory
				});

			});

		}

		if (allArtShadeLink) {

			allArtShadeLink.addEventListener('click', (e) => {

				const { category } = e.currentTarget.dataset;
				utagLinkPDP()({
					eventAction: `Click-All-${category.trim().replace(/\s/, '-')}`,
					eventLabel: window.shortSku
				});

			});

		}

		initBreadcrumbTracking();
		initBreadcrumbBack();

		// track system options qty update
		document.querySelectorAll('.systemOptionsQty').forEach((input) => {

			input.dataset.qty = input.value.trim() || '';

			input.addEventListener('blur', (e) => {

				const qty = e.currentTarget.value.trim();
				if (qty !== e.currentTarget.dataset.qty) {

					utagLinkPDP()({
						eventAction: 'Update-BFS-QTY',
						eventLabel: window.location.pathname
					});
					e.currentTarget.dataset.qty = qty;

				}

			});

		});

	}

	return Object.freeze({ init });

}

export default initCommon;
